const resetFiltros = ({ commit }) => {
  commit('RESET_FILTROS')
}

const resetFiltrosOpcoes = ({ commit }) => {
  commit('RESET_FILTROS_OPCOES')
}

const changeFilter = ({ commit }, payload) => {
  commit('CHANGE_FILTER', payload)
}

const updateFilters = ({ commit }, payload) => {
  commit('UPDATE_ALL_FILTERS', payload)
}

const loadingProfissionais = ({ commit }, payload) => {
  commit('SET_LOADING_PROFISSIONAIS', payload)
}

const setProfissionais = ({ commit }, payload) => {
  commit('SET_PROFISSIONAIS', payload)
}

const addProfissionais = ({ commit }, payload) => {
  commit('ADD_PROFISSIONAIS', payload)
}

const removeProfissional = ({ commit }, payload) => {
  commit('REMOVE_PROFISSIONAL', payload)
}

const setSegmentos = ({ commit }, payload) => {
  commit('SET_SEGMENTOS', payload)
}

const setSegmentosLoading = ({ commit }, payload) => {
  commit('SET_SEGMENTOS_LOADING', payload)
}

const setHierarquiaEmpresas = ({ commit }, payload) => {
  commit('SET_HIERARQUIA_EMPRESAS', payload)
}

const hierarquiaEmpresasLoading = ({ commit }, payload) => {
  commit('SET_HIERARQUIA_EMPRESA_LOADING', payload)
}

const setEmpresas = ({ commit }, payload) => {
  commit('SET_EMPRESAS', payload)
}

const setEmpresasLoading = ({ commit }, payload) => {
  commit('SET_EMPRESAS_LOADING', payload)
}

const setPlanosCarreira = ({ commit }, payload) => {
  commit('SET_PLANOS_CARREIRA', payload)
}

const setPlanosCarreiraLoading = ({ commit }, payload) => {
  commit('SET_PLANOS_CARREIRA_LOADING', payload)
}

const setPlanoCarreiraSelecionado = ({ commit }, payload) => {
  commit('SET_PLANO_CARREIRA_SELECIONADO', payload)
}

const setPlanoCarreiraSelecionadoLoading = ({ commit }, payload) => {
  commit('SET_PLANO_CARREIRA_SELECIONADO_LOADING', payload)
}

const updateDadoPlanoCarreira = ({ commit }, payload) => {
  commit('UPDATE_DADO_PLANO_CARREIRA_SELECIONADO', payload)
}

const removeDadoPlanoCarreira = ({ commit }, payload) => {
  commit('REMOVE_DADO_PLANO_CARREIRA', payload)
}

const setDadoPlanoCarreiraLoading = ({ commit }, payload) => {
  commit('SET_DADO_PLANO_CARREIRA_LOADING', payload)
}

const setQuadrantes = ({ commit }, payload) => {
  commit('SET_QUADRANTES', payload)
}

const setQuadrantesLoading = ({ commit }, payload) => {
  commit('SET_QUADRANTES_LOADING', payload)
}

const setSenioridade = ({ commit }, payload) => {
  commit('SET_SENIORIDADE', payload)
}

const setSenioridadeLoading = ({ commit }, payload) => {
  commit('SET_SENIORIDADE_LOADING', payload)
}

const addSenioridade = ({ commit }, payload) => {
  commit('ADD_SENIORIDADE', payload)
}

const removeSenioridade = ({ commit }, payload) => {
  commit('REMOVE_SENIORIDADE', payload)
}

const setDadosGerais = ({ commit }, payload) => {
  commit('SET_DADOS_GERAIS', payload)
}

const setDadosGeraisLoading = ({ commit }, payload) => {
  commit('SET_DADOS_GERAIS_LOADING', payload)
}

const setDocumentos = ({ commit }, payload) => {
  commit('SET_DOCUMENTOS', payload)
}

const setDocumentosLoading = ({ commit }, payload) => {
  commit('SET_DOCUMENTOS_LOADING', payload)
}

const removeDocumento = ({ commit }, payload) => {
  commit('REMOVE_DOCUMENTOS', payload)
}

const setFinanceiroUnico = ({ commit }, payload) => {
  commit('SET_FINANCEIRO_UNICO', payload)
}

const setFinanceiroUnicoLoading = ({ commit }, payload) => {
  commit('SET_FINANCEIRO_UNICO_LOADING', payload)
}

const setFinanceiroConversao = ({ commit }, payload) => {
  commit('SET_FINANCEIRO_CONVERSAO', payload)
}

const setFinanceiroConversaoLoading = ({ commit }, payload) => {
  commit('SET_FINANCEIRO_CONVERSAO_LOADING', payload)
}

const setFinanceiroComissao = ({ commit }, payload) => {
  commit('SET_FINANCEIRO_COMISSAO', payload)
}

const setFinanceiroComissaoLoading = ({ commit }, payload) => {
  commit('SET_FINANCEIRO_COMISSAO_LOADING', payload)
}

const setParametrosRegioes = ({ commit }, payload) => {
  commit('SET_PARAMETROS_REGIOES', payload)
}

const setParametrosRegioesLoading = ({ commit }, payload) => {
  commit('SET_PARAMETROS_REGIOES_LOADING', payload)
}

const setParametrosSegmentos = ({ commit }, payload) => {
  commit('SET_PARAMETROS_SEGMENTOS', payload)
}

const setParametrosSegmentosLoading = ({ commit }, payload) => {
  commit('SET_PARAMETROS_SEGMENTOS_LOADING', payload)
}

const setParametrosContratacoes = ({ commit }, payload) => {
  commit('SET_PARAMETROS_CONTRATACOES', payload)
}

const setParametrosContratacoesLoading = ({ commit }, payload) => {
  commit('SET_PARAMETROS_CONTRATACOES_LOADING', payload)
}

const preencherIdsParametrosContratacoes = ({ commit }, payload) => {
  commit('PREENCHER_IDS_PARAMETROS_CONTRATACOES', payload)
}

const setParametrosIncentivos = ({ commit }, payload) => {
  commit('SET_PARAMETROS_INCENTIVOS', payload)
}

const setParametrosIncentivosLoading = ({ commit }, payload) => {
  commit('SET_PARAMETROS_INCENTIVOS_LOADING', payload)
}

const setParametrosMetasEscritorio = ({ commit }, payload) => {
  commit('SET_PARAMETROS_METAS_ESCRITORIO', payload)
}

const setParametrosMetasEscritorioLoading = ({ commit }, payload) => {
  commit('SET_PARAMETROS_METAS_ESCRITORIO_LOADING', payload)
}

const setParametrosMetasProfissionais = ({ commit }, payload) => {
  commit('SET_PARAMETROS_METAS_PROFISSIONAIS', payload)
}

const setParametrosMetasProfissionaisLoading = ({ commit }, payload) => {
  commit('SET_PARAMETROS_METAS_PROFISSIONAIS_LOADING', payload)
}

const setProjecaoAuC = ({ commit }, payload) => {
  commit('SET_PROJECAO_AUC', payload)
}

const setProjecaoAuCLoading = ({ commit }, payload) => {
  commit('SET_PROJECAO_AUC_LOADING', payload)
}

const setHistoricoAuC = ({ commit }, payload) => {
  commit('SET_HISTORICO_AUC', payload)
}

const setHistoricoAuCLoading = ({ commit }, payload) => {
  commit('SET_HISTORICO_AUC_LOADING', payload)
}

const setHistoricoAuCProfissional = ({ commit }, payload) => {
  commit('SET_HISTORICO_AUC_PROFISSIONAL', payload)
}

const setHistoricoAuCProfissionalLoading = ({ commit }, payload) => {
  commit('SET_HISTORICO_AUC_PROFISSIONAL_LOADING', payload)
}

const setContratacoesEfetivadas = ({ commit }, payload) => {
  commit('SET_CONTRATACOES_EFETIVADAS', payload)
}

const setContratacoesEfetivadasLoading = ({ commit }, payload) => {
  commit('SET_CONTRATACOES_EFETIVADAS_LOADING', payload)
}

const removeContratacaoEfetivada = ({ commit }, payload) => {
  commit('REMOVE_CONTRATACAO_EFETIVADA', payload)
}

const setParametrosAdicionais = ({ commit }, payload) => {
  commit('SET_PARAMETROS_ADICIONAIS', payload)
}

const setParametrosAdicionaisLoading = ({ commit }, payload) => {
  commit('SET_PARAMETROS_ADICIONAIS_LOADING', payload)
}

const setCustosAdicionais = ({ commit }, payload) => {
  commit('SET_CUSTOS_ADICIONAIS', payload)
}

const setCustosAdicionaisLoading = ({ commit }, payload) => {
  commit('SET_CUSTOS_ADICIONAIS_LOADING', payload)
}

const setHistoricoPlanilhas = ({ commit }, payload) => {
  commit('SET_HISTORICO_PLANILHAS', payload)
}

const setHistoricoPlanilhasLoading = ({ commit }, payload) => {
  commit('SET_HISTORICO_PLANILHAS_LOADING', payload)
}

export const setMultiplos = ({ commit }, payload) => {
  commit('SET_MULTIPLOS', payload)
}

export const setMultiplosLoading = ({ commit }, payload) => {
  commit('SET_MULTIPLOS_LOADING', payload)
}

const setExternAgents = ({ commit }, payload) => {
  commit('SET_EXTERN_AGENTS', payload)
}

const addExternAgents = ({ commit }, payload) => {
  commit('ADD_EXTERN_AGENTS', payload)
}

const setExternAgentsLoading = ({ commit }, payload) => {
  commit('SET_EXTERN_AGENTS_LOADING', payload)
}

const setPartnershipsProfessionals = ({ commit }, payload) => {
  commit('SET_PARTNERSHIPS_PROFESSIONALS', payload)
}

const addPartnershipsProfessionals = ({ commit }, payload) => {
  commit('ADD_PARTNERSHIPS_PROFESSIONALS', payload)
}

const setPartnershipsProfessionalsLoading = ({ commit }, payload) => {
  commit('SET_PARTNERSHIPS_PROFESSIONALS_LOADING', payload)
}

const setPartnershipsExternAgents = ({ commit }, payload) => {
  commit('SET_PARTNERSHIPS_EXTERN_AGENTS', payload)
}

const addPartnershipsExternAgents = ({ commit }, payload) => {
  commit('ADD_PARTNERSHIPS_EXTERN_AGENTS', payload)
}

const setPartnershipsExternAgentsLoading = ({ commit }, payload) => {
  commit('SET_PARTNERSHIPS_EXTERN_AGENTS_LOADING', payload)
}

export const setFiliais = ({ commit }, payload) => {
  commit('SET_FILIAIS', payload)
}

export const addFiliais = ({ commit }, payload) => {
  commit('ADD_FILIAIS', payload)
}

export const setFiliaisLoading = ({ commit }, payload) => {
  commit('SET_FILIAIS_LOADING', payload)
}

export const setProjecaoAucTeam = ({ commit }, payload) => {
  commit('SET_PROJECAO_AUC_TEAM', payload)
}

export const setProjecaoAucTeamLoading = ({ commit }, payload) => {
  commit('SET_PROJECAO_AUC_TEAM_LOADING', payload)
}

export const setDataRoomFiles = ({ commit }, payload) => {
  commit('SET_DATA_ROOM_FILES', payload)
}
export const addDataRoomFiles = ({ commit }, payload) => {
  commit('ADD_DATA_ROOM_FILES', payload)
}
export const setDataRoomFilesLoading = ({ commit }, payload) => {
  commit('SET_DATA_ROOM_FILES_LOADING', payload)
}
export const setDataRoomOptions = ({ commit }, payload) => {
  commit('SET_DATA_ROOM_OPTIONS', payload)
}
export const setDataRoomOptionsLoading = ({ commit }, payload) => {
  commit('SET_DATA_ROOM_OPTIONS_LOADING', payload)
}

export const setOptionsFilterAuc = ({ commit }, payload) => {
  commit('SET_OPTION_FILTER_AUC', payload)
}

export const setOptionsFilterActive = ({ commit }, payload) => {
  commit('SET_OPTION_FILTER_ACTIVE', payload)
}

export const setOptionsRequiredFiles = ({ commit }, payload) => {
  commit('SET_OPTION_REQUIRED_FILE', payload)
}

export const setDataRoomSelectedYear = ({ commit }, payload) => {
  commit('SET_DATA_ROOM_SELECTED_YEAR', payload)
}

export {
  resetFiltros,
  resetFiltrosOpcoes,
  changeFilter,
  updateFilters,
  loadingProfissionais,
  setProfissionais,
  addProfissionais,
  removeProfissional,
  setSegmentos,
  setSegmentosLoading,
  setHierarquiaEmpresas,
  hierarquiaEmpresasLoading,
  setEmpresas,
  setEmpresasLoading,
  setPlanosCarreira,
  setPlanosCarreiraLoading,
  setPlanoCarreiraSelecionado,
  setPlanoCarreiraSelecionadoLoading,
  updateDadoPlanoCarreira,
  removeDadoPlanoCarreira,
  setDadoPlanoCarreiraLoading,
  setQuadrantes,
  setQuadrantesLoading,
  setSenioridade,
  setSenioridadeLoading,
  addSenioridade,
  removeSenioridade,
  setDadosGerais,
  setDadosGeraisLoading,
  setDocumentos,
  setDocumentosLoading,
  removeDocumento,
  setFinanceiroUnico,
  setFinanceiroUnicoLoading,
  setFinanceiroConversao,
  setFinanceiroConversaoLoading,
  setFinanceiroComissao,
  setFinanceiroComissaoLoading,
  setParametrosRegioes,
  setParametrosRegioesLoading,
  setParametrosSegmentos,
  setParametrosSegmentosLoading,
  setParametrosContratacoes,
  setParametrosContratacoesLoading,
  preencherIdsParametrosContratacoes,
  setParametrosIncentivos,
  setParametrosIncentivosLoading,
  setParametrosMetasEscritorio,
  setParametrosMetasEscritorioLoading,
  setParametrosMetasProfissionais,
  setParametrosMetasProfissionaisLoading,
  setProjecaoAuC,
  setProjecaoAuCLoading,
  setHistoricoAuC,
  setHistoricoAuCLoading,
  setHistoricoAuCProfissional,
  setHistoricoAuCProfissionalLoading,
  setContratacoesEfetivadas,
  setContratacoesEfetivadasLoading,
  removeContratacaoEfetivada,
  setParametrosAdicionais,
  setParametrosAdicionaisLoading,
  setCustosAdicionais,
  setCustosAdicionaisLoading,
  setHistoricoPlanilhas,
  setHistoricoPlanilhasLoading,
  setExternAgents,
  addExternAgents,
  setExternAgentsLoading,
  setPartnershipsProfessionals,
  addPartnershipsProfessionals,
  setPartnershipsProfessionalsLoading,
  setPartnershipsExternAgents,
  addPartnershipsExternAgents,
  setPartnershipsExternAgentsLoading,
}
